import React from "react";
import styled from "styled-components";
import { deviceSize } from "../responsive";
// import { useMediaQuery } from "react-responsive";



import JoinUs from "../../images/JointheTeamPhoto.webp";
import JoinUsMob from "../../images/mobileImages/JoinMobile.webp"


const EmploymentAdContainer = styled.div`

	width:100%;
	height:800px;
  display:flex;
  background:url(${JoinUs}) no-repeat;
  background-size: cover;
  

  align-items: center;
  justify-content:flex-start;



 @media screen and (max-width:${deviceSize.laptop}px){
        background-size:cover;
 }

 @media screen and (max-width:${deviceSize.slaptop}px){

  width:100%;
    height:600px;
  }




@media screen and (max-width: ${deviceSize.mobile}px){

  height:414px;
  width:100%;
   background:url(${JoinUsMob}) no-repeat;
   background-size:cover;

 }

`;

const ContentContainer = styled.div`

  width: 100%;
  height:100%;
  display: flex;
  align-items: center;
  justify-content: center;

 @media screen and (max-width: ${deviceSize.mobile}px)
 {
   
  
 }

`;


const SloganContainer =styled.div`
  display:flex;
  height: 100%;
  justify-content: center;
  align-items:center;
  flex-direction:column;

   @media screen and (max-width: ${deviceSize.mobile}px)
   {
    align-items:center;
    width: 55%;
   }

`;

const Slogant= styled.p`
  font-size: 22px;
  font-weight: 300;
  line-height: 25px;
  text-align: left;
  font-family: Sunflower, Helvetica, arial;
  color: #000000;
  text-align: center;
  font-family: Sunflower;
  position: relative;
  top: -15%;



 @media screen and (max-width: ${deviceSize.mobile}px)
 {
  	font-size: 12px;
    align-items: center;
    margin: 0;
 }



`;


 const Sloganb= styled.p`
  max-width:440px;
  font-size: 22px;
  font-weight: 100;
  line-height: 25px;
  text-align:left;
  font-family:"Sunflower","Helvetica","arial";
  color: #000000;
  text-align:center;
  font-family: Sunflower;
  position: relative;
  top: -11%;



 @media screen and (max-width: ${deviceSize.mobile}px)
 {
    font-size:12px;
    align-items:center;
    margin: 0;
 }
`;



const SloganHeader = styled.h3`
width: 400px;
text-align:center;
font-family: Sunflower;
font-style: normal;
font-weight: 500;
font-size: 33px;
line-height: 41px;
color: #ffffff;
font-size: 50px;
margin-bottom:50px;
margin-right:5%;
margin-left:5%;
position: relative;
top: -20%;


@media screen and (max-width: ${deviceSize.mobile}px)
 {
    font-size:28px;
    margin: 0;
    width:100%;
 
 }




`;

export function EmploymentAd(props){

	// const isMobile = useMediaQuery ({maxWidth:deviceSize.mobile});

	return (
		<EmploymentAdContainer id="employment">
			<ContentContainer>
          <SloganContainer>
    				<SloganHeader>Join The Team!</SloganHeader>
              <Slogant>
                 Our Virtual doors are always open.
               </Slogant>
              <Sloganb> 
                <a style={{color: "#FFFFFF", textDecoration: "underline"}}href="mailto:info@exp-staffing.com">Shoot us an email</a> attaching your resume.
                If you're a fit, we'll reach out!
              </Sloganb>
        </SloganContainer>
        </ContentContainer>
		  </EmploymentAdContainer>		
		);
} 
